module.exports = __webpack_public_path__ + "img/Weilin Vision J-type metal detection software.76f48d42.jpg";